/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DescriptionInputs */



/**
* | output |
* | --- |
* | "Description" |
*
* @param {Common_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_description = /** @type {((inputs?: Common_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Descrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione")
	return /** @type {LocalizedString} */ ("Description")
});